import * as React from "react";
import styled from "styled-components";
import { DesignExtend, ElementableType, ElementModel, FlipType, FontStyle, TextAlignType, TextDecoration } from "./PrintProductModel";
import Common from "../based/Common";

export const ThumbnailArtworkUrl = ({ width, height, url, boundaryWidth, boundaryHeight, boundaryX, boundaryY, dimensionWidth, elements = [new ElementModel()], hideBackground = false, designExtend = new DesignExtend() }) => {
    let ratio = dimensionWidth > 0 ? parseFloat(width / dimensionWidth) : 0;
    boundaryWidth = ratio * boundaryWidth;
    boundaryHeight = ratio * boundaryHeight;
    boundaryX = ratio * boundaryX;
    boundaryY = ratio * boundaryY;
    function _getCssTextAlign(alignType) {
        switch (alignType) {
            case TextAlignType.Left:
                return "left";
            case TextAlignType.Right:
                return "right";
            case TextAlignType.Center:
                return "center";
            case TextAlignType.Justify:
                return "justify";
            default:
                break;
        }
    }

    const warningZone = designExtend.variantWarningZone;

    return (
        <EditorWrapper>
            <div id="print_body-image" className="print_body-image select-none" style={{ width: width, height: height, position: "relative" }}>
                {/* Lớp Background */}
                {!hideBackground &&
                    (warningZone && warningZone.bottomLayer ? (
                        <img className="print_body-url select-none" src={warningZone.bottomLayer} style={{ width: width, height: height }} />
                    ) : (
                        <img className="print_body-url select-none" src={url} style={{ width: width, height: height }} />
                    ))}

                {/* Lớp họa tiết */}
                <div className="position-absolute overflow-hidden off-boundary select-none" style={{ width: `${boundaryWidth}px`, height: `${boundaryHeight}px`, top: `${boundaryY}px`, left: `${boundaryX}px` }}>
                    {elements &&
                        elements.map((imageDetail, idx) => {
                            let posX = imageDetail.posX * ratio;
                            let posY = imageDetail.posY * ratio;
                            let posWidth = imageDetail.posWidth * ratio;
                            let posHeight = imageDetail.posHeight * ratio;
                            let objectX = imageDetail.objectX * ratio;
                            let objectY = imageDetail.objectY * ratio;
                            let objectWidth = imageDetail.objectWidth * ratio;
                            let objectHeight = imageDetail.objectHeight * ratio;
                            let zIndex = imageDetail.zIndex;
                            let posDegree = imageDetail.posDegree;

                            let thumbUrl = imageDetail.thumbUrl;
                            if (imageDetail.elementableType == ElementableType.Image) {
                                if (!imageDetail.thumbUrl) return "";
                                var extension = Common.getFileExtension(imageDetail.thumbUrl);
                                if (extension != ".svg" && imageDetail.stockVariantThumbs && imageDetail.stockVariantThumbs.length > 0) {
                                    thumbUrl = imageDetail.stockVariantThumbs[0].url;
                                }
                            }

                            var imageUrl = imageDetail.replaceUrl || imageDetail.blobUrl || thumbUrl;

                            return (
                                <Wrapper key={idx}>
                                    <div
                                        id={`parent-item-${imageDetail.id}`}
                                        className="parent-item select-none"
                                        style={{
                                            width: posWidth > 0 ? posWidth : "100%",
                                            height: posHeight > 0 ? posHeight : "100%",
                                            transform: `translate(${posX}px,${posY}px) rotate(${posDegree}deg)`,
                                            zIndex: zIndex,
                                            overflow: "hidden",
                                        }}
                                    >
                                        <div
                                            className="element-item select-none"
                                            style={{
                                                width: objectWidth > 0 ? objectWidth : "100%",
                                                height: objectHeight > 0 ? objectHeight : "100%",
                                                transform: `
                                                translate(${objectX}px,${objectY}px) 
                                                rotate(0deg)   
                                                scaleX(${imageDetail.listFlipType?.includes(FlipType.Horizontal) ? "-1" : "1"}) 
                                                scaleY(${imageDetail.listFlipType?.includes(FlipType.Vertical) ? "-1" : "1"})`,
                                            }}
                                        >
                                            {imageDetail.elementableType == ElementableType.Image ? (
                                                imageDetail.blobUrl ? (
                                                    <div className="wh-100">
                                                        <img
                                                            src={imageDetail.blobUrl}
                                                            onContextMenu={(e) => {
                                                                return false;
                                                            }}
                                                            className="noselect"
                                                            style={{ pointerEvents: "none", willChange: "transform" }}
                                                        />
                                                    </div>
                                                ) : (
                                                    <div className="wh-100">
                                                        <img
                                                            src={imageUrl}
                                                            onContextMenu={(e) => {
                                                                return false;
                                                            }}
                                                            className="noselect"
                                                            style={{ pointerEvents: "none", willChange: "transform" }}
                                                        />
                                                    </div>
                                                )
                                            ) : imageDetail.isCurve && imageDetail.listObjectCurve ? (
                                                <React.Fragment>
                                                    <div
                                                        className="curve-wrapper"
                                                        style={{
                                                            width: imageDetail.posWidth * ratio,
                                                            height: imageDetail.posHeight * ratio,
                                                            position: "absolute",
                                                        }}
                                                    >
                                                        <div className="curve-list">
                                                            {imageDetail.listObjectCurve.map((element, index) => {
                                                                return (
                                                                    <div
                                                                        key={index}
                                                                        id={`curve-${element.id}`}
                                                                        className="curve-item"
                                                                        style={{
                                                                            fontFamily: `'${imageDetail.fontFamily}'`,
                                                                            fontSize: `${imageDetail.fontSize * (imageDetail.scale || 1) * ratio}px`,
                                                                            color: imageDetail.fontColor,
                                                                            fontWeight: imageDetail.fontWeight,
                                                                            lineHeight: `${imageDetail.fontSize * ratio * imageDetail.lineSpacing}px`,
                                                                            opacity: "1",
                                                                            fontStyle: imageDetail.fontStyle == FontStyle.Italic ? "italic" : "normal",
                                                                            textDecoration: imageDetail.textDecoration == TextDecoration.Underline ? "underline" : "normal",
                                                                            textAlign: GetCssTextAlign(imageDetail.textAlign),
                                                                            display: "inline-block",
                                                                            margin: 0,
                                                                            width: element.dimension.width * ratio,
                                                                            height: element.dimension.height * ratio,
                                                                            transform: `translate(${element.aResult.x * ratio}px,${element.aResult.y * ratio}px) rotate(${element.deg}deg)`,
                                                                            whiteSpace: "pre",
                                                                        }}
                                                                    >
                                                                        {element.character}
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                </React.Fragment>
                                            ) : (
                                                <div
                                                    role="textbox"
                                                    style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        border: "none",
                                                    }}
                                                >
                                                    <p
                                                        className="text-item"
                                                        style={{
                                                            fontFamily: `'${imageDetail.fontFamily}'`,
                                                            fontSize: imageDetail.fontSize * (imageDetail.scale || 1) * ratio,
                                                            color: imageDetail.fontColor,
                                                            fontWeight: imageDetail.fontWeight,
                                                            lineHeight: `${imageDetail.fontSize * ratio * imageDetail.lineSpacing}px`,
                                                            opacity: "1",
                                                            fontStyle: imageDetail.fontStyle == FontStyle.Italic ? "italic" : "normal",
                                                            textDecoration: imageDetail.textDecoration == TextDecoration.Underline ? "underline" : "none",
                                                            textAlign: GetCssTextAlign(imageDetail.textAlign),
                                                            display: "inline-block",
                                                            letterSpacing: imageDetail.letterSpacing > 0 ? imageDetail.letterSpacing : 0,
                                                            margin: 0,
                                                            transformOrigin: "top left",
                                                            width: "100%",
                                                            height: "100%",
                                                            whiteSpace: "pre",
                                                        }}
                                                    >
                                                        {imageDetail.fontText &&
                                                            imageDetail.fontText.split("\n").map((txt, txtIdx) => {
                                                                return (
                                                                    <span
                                                                        key={txtIdx}
                                                                        style={{
                                                                            width: imageDetail.fontStyle == FontStyle.Italic ? "105%" : "100%",
                                                                        }}
                                                                    >
                                                                        {txt}
                                                                    </span>
                                                                );
                                                            })}
                                                    </p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </Wrapper>
                            );
                        })}
                </div>

                {/* Lớp trên cùng */}
                {!hideBackground && warningZone && (
                    <div
                        className="warning-zone"
                        style={{
                            position: "absolute",
                            width: width,
                            height: height,
                            pointerEvents: "none",
                            top: 0,
                            left: 0,
                            zIndex: 100,
                        }}
                    >
                        <img
                            style={{
                                position: "absolute",
                            }}
                            src={warningZone.topLayer}
                        />
                    </div>
                )}
            </div>
        </EditorWrapper>
    );
};

const Wrapper = styled.div`
    .wh-100 {
        width: 100%;
        height: 100%;
        img {
            width: 100% !important;
            height: 100% !important;
        }
    }
    .noselect {
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
    }
    .edit-area {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .parent-item {
        position: absolute;
    }
    .element-item {
        display: inline-block;
        position: absolute;
        width: 100%;
        height: 100%;
        img {
            height: 100%;
            width: 100%;
            object-fit: fill;
            position: absolute;
        }
    }
    .outline {
        position: absolute;
        border: 0.5px solid #f20e45;
        visibility: hidden;
        opacity: 0;
        transition: visibility 0s, opacity 0.5s linear;
        z-index: 0;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .outline.active {
        visibility: visible;
        opacity: 1;
    }
    .scale-button {
        padding: 10px;
        width: 30px;
        height: 30px;
    }
    .rounded-button {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: white;
        border: 0.5px solid #f20e45;
    }
    .hidden-item {
        opacity: 0.01;
    }
    .scale-button-container {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .scale-button-container::before {
        transition: transform 0.1s linear, -webkit-transform 0.1s linear;
        content: "";
        border-radius: 50%;
        width: 64px;
        height: 64px;
        background-color: hsla(0, 0%, 100%, 0.4);
        box-shadow: 0 0 4px 1px rgb(47 64 80 / 25%);
        position: absolute;
        pointer-events: none;
        transform: scale(0);
    }
    .scale-button-container.active::before {
        transform: scale(1);
    }
    .rotate-button-container {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .rotate-button-container::before {
        transition: transform 0.1s linear, -webkit-transform 0.1s linear;
        content: "";
        border-radius: 50%;
        width: 64px;
        height: 64px;
        background-color: hsla(0, 0%, 100%, 0.4);
        box-shadow: 0 0 4px 1px rgb(47 64 80 / 25%);
        position: absolute;
        pointer-events: none;
        transform: scale(0);
    }
    .rotate-button-container.active::before {
        transform: scale(1);
    }
    .edit-button-container {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        top: -50px;
        background: white;
        border-radius: 10px;
        padding: 5px 10px;
        .edit-button-item {
            margin: 0 5px;
        }
    }
    .scale-horizontal-button {
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px;
        .horizontal-button {
            border-radius: 3px;
            width: 6px;
            height: 18px;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #fff;
            box-shadow: 0 0 4px 1px rgb(57 76 96 / 15%), 0 0 0 1px rgb(47 64 80 / 25%);
        }
        .vertical-button {
            border-radius: 3px;
            width: 18px;
            height: 6px;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #fff;
            box-shadow: 0 0 4px 1px rgb(57 76 96 / 15%), 0 0 0 1px rgb(47 64 80 / 25%);
            padding: 0 5px;
        }
    }
    .scale-horizontal-button::before {
        transition: transform 0.1s linear, -webkit-transform 0.1s linear;
        content: "";
        border-radius: 50%;
        width: 64px;
        height: 64px;
        background-color: hsla(0, 0%, 100%, 0.4);
        box-shadow: 0 0 4px 1px rgb(47 64 80 / 25%);
        position: absolute;
        pointer-events: none;
        transform: scale(0);
    }
    .scale-horizontal-button.active::before {
        transform: scale(1);
    }

    .scale-horizontal-button.right {
        right: 0;
    }
    .scale-horizontal-button.left {
        left: 0;
    }
    .scale-horizontal-button.top {
        top: 0;
    }
    .scale-horizontal-button.bottom {
        bottom: 0;
    }
    p[contenteditable] {
        border: 0;
        span {
            border: 0;
        }
    }
`;

export const EditorWrapper = styled.div`
    /* touch-action: "pan-x pan-y pinch-zoom"; */
    user-select: none;
    .print_body-url {
        position: absolute;
    }
    .overflow-hidden {
        overflow: hidden;
    }
    .print-boundary {
        border: 0.5px solid rgba(255, 255, 255, 0.3);
    }
    .print-boundary.off-boundary {
        border: 0.5px solid rgba(255, 255, 255, 0) !important;
    }
    .print-boundary.border-dark {
        border: 0.5px solid rgba(255, 255, 255, 0.3);
    }
    .print-boundary-without-border {
        overflow: hidden;
    }
    .text-item {
        display: inline-block;
        position: absolute;
        top: 0;
    }
    .parent-item {
        position: absolute;
    }
    .element-item {
        display: inline-block;
        position: absolute;
        width: 100%;
        height: 100%;
        img {
            position: absolute;
            width: 100%;
            height: 100%;
        }
        span {
            display: block;
        }
        svg {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
        }
    }
    .curve-list {
        position: absolute;
        height: 100%;
        width: 100%;
    }
    .curve-item {
        position: absolute;
        left: 50%;
    }
    .transform-kit {
        transition: transform 0.5s;
        -webkit-transition: transform 0.5s;
        -moz-transition: transform 0.5s;
    }
`;

export function GetCssTextAlign(alignType) {
    switch (alignType) {
        case TextAlignType.Left:
            return "left";
        case TextAlignType.Right:
            return "right";
        case TextAlignType.Center:
            return "center";
        case TextAlignType.Justify:
            return "justify";
        default:
            return "left";
    }
}
